import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Root = styled.span`
  display: flex;
  color: #ffffff;
  font-size: 40px;
  font-weight: bold;
  line-height: 48px;
  position: relative;
  text-align: center;
  align-self: stretch;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

function Title({ children, className }) {
  return <Root className={className}>{children}</Root>;
}

Title.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

Title.defaultProps = {
  className: '',
};

export default Title;
